import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "root-order-list" };
const _hoisted_2 = { class: "related-order-list store-type" };
const _hoisted_3 = { class: "related-order-list__title" };
const _hoisted_4 = { class: "float-right" };
const _hoisted_5 = { class: "target-icon store-type" };
const _hoisted_6 = { class: "ml-1" };
const _hoisted_7 = { class: "related-order-list__body" };
const _hoisted_8 = { class: "related-order-list worker-type" };
const _hoisted_9 = { class: "related-order-list__title" };
const _hoisted_10 = { class: "float-right" };
const _hoisted_11 = { class: "target-icon worker-type" };
const _hoisted_12 = { class: "ml-1" };
const _hoisted_13 = { class: "related-order-list__body" };
import { computed, onMounted, ref, } from 'vue';
import { addEventList, emitEvent, } from '@/eventBus';
import { eventBusEvent, mapControl, } from '@/constants';
import { i18n } from '@/locales';
import OrderItem from '@/views/MapControl/OrderWrapper/OrderItem.vue';
import vuexStore from '@/vuex-store';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import { mapControlActionType } from '@/vuex-store/map-control/actions';
import { mapControlGetterType } from '@/vuex-store/map-control/getters';
const lc = 'views.map_control.order_wrapper.order_list.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrderList',
    setup(__props) {
        const orderListOuter = ref(null);
        const orderList = ref({});
        const searchOrderQuery = computed(() => vuexStore.state.mapControl.searchOrderQuery);
        const selectedWorker = computed(() => vuexStore.state.mapControl.selectedWorker);
        const getterSelectedStoreOrderList = computed(() => vuexStore
            .getters[mapControlGetterType.getterSelectedStoreOrderList]);
        const getterSelectedWorkerOrderList = computed(() => vuexStore
            .getters[mapControlGetterType.getterSelectedWorkerOrderList]);
        const includesSelectedItemList = computed(() => vuexStore.getters[mapControlGetterType.includesSelectedItemList]);
        const getterMainOrderList = computed(() => vuexStore.getters[mapControlGetterType.getterMainOrderList]);
        const getterOrderList = computed(() => vuexStore.getters[mapControlGetterType.getterOrderList]);
        const getterSelectedStoreData = computed(() => vuexStore.getters[mapControlGetterType.getterSelectedStoreData]);
        const hubId = computed(() => vuexStore.getters['user/hubId']);
        const storeName = computed(() => getterSelectedStoreData.value.storeName);
        const workerName = computed(() => selectedWorker.value?.user?.name);
        const resultText = computed(() => (searchOrderQuery.value
            ? i18n.t(`${lc}empty_search_order`, [
                searchOrderQuery.value,
            ])
            : i18n.t(`${lc}empty_order`)));
        const isEmpty = computed(() => {
            const result = !Object.keys(getterMainOrderList.value).length
                && !Object.keys(getterSelectedWorkerOrderList.value).length
                && !Object.keys(getterSelectedStoreOrderList.value).length;
            return result;
        });
        /**
         * handler 상점 연관 주문 클릭 핸들러
         * @param orderData 주문 데이터
         */
        const handleClickOrderItemForStore = (orderData) => {
            const payload = {
                orderData,
                type: mapControl.marker.STORE,
            };
            emitEvent(eventBusEvent.MapWrapper_handleClickOrder, payload);
        };
        /**
         * handler 워커 연관 주문 클릭 핸들러
         * @param orderData 주문 객체
         * @param target 이벤트 대상 (배달요청, 상점 연관, 배달 연관)
         */
        const handleClickOrderItemForWorker = (orderData) => {
            const payload = {
                orderData,
                type: mapControl.marker.WORKER,
            };
            emitEvent(eventBusEvent.MapWrapper_handleClickOrder, payload);
        };
        /**
         * handler 주문 리스트 클릭 핸들러
         * @param orderData 주문 객체
         */
        const handleClickOrderItem = (orderData) => {
            const payload = {
                orderData,
                type: mapControl.marker.DROP,
            };
            emitEvent(eventBusEvent.MapWrapper_handleClickOrder, payload);
        };
        /**
         * 라이더 닫기 버튼 클릭
         */
        const handleClickWorkerClose = () => {
            emitEvent(eventBusEvent.MapWrapper_handleClickWorker, selectedWorker.value);
        };
        /**
         * 상점 닫기 버튼 클릭
         */
        const handleClickStoreClose = () => {
            emitEvent(eventBusEvent.MapWrapper_handleClickStore, getterSelectedStoreData.value);
        };
        /**
         * 해당 주문으로 스크롤 이동
         * @param orderId
         */
        const goToSelectedOrder = (orderId) => {
            const findCurrentList = getterMainOrderList.value.find((data) => data.orderId === orderId);
            const findOriginList = Object.values(getterOrderList.value).find((data) => data.orderId === orderId);
            // 오더리스트에는 있지만 필터나 검색으로 인해 현재 필터된 오더리스트에 안보인다면 검색어와 필터 초기화
            if (!findCurrentList && findOriginList) {
                emitEvent(eventBusEvent.MapWrapper_resetSearchQuery);
                vuexStore.dispatch(mapControlActionType.setOrderFilter);
                vuexStore.dispatch(snackbarActionType.showSuccess, {
                    message: i18n.t('views.map_control.order_wrapper.clear_filters'),
                });
            }
            const selectedOrderItem = orderList.value[orderId];
            if (selectedOrderItem) {
                // eslint-disable-next-line no-unsafe-optional-chaining
                const { offsetTop } = selectedOrderItem?.$el;
                orderListOuter.value.scrollTop = offsetTop;
            }
        };
        onMounted(() => {
            addEventList({
                [eventBusEvent.MapWrapper_goToSelectedOrder]: goToSelectedOrder,
            });
        });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_card_text = _resolveComponent("v-card-text");
            const _component_v_card = _resolveComponent("v-card");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createCommentVNode(" 선택된 상점의 배달 요청건 "),
                _withDirectives(_createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("span", _hoisted_4, [
                            _createVNode(_component_v_icon, {
                                class: "btn-close-related-order",
                                color: "black",
                                onClick: handleClickStoreClose
                            }, {
                                default: _withCtx(() => _cache[0] || (_cache[0] = [
                                    _createTextVNode(" mdi-close ")
                                ])),
                                _: 1 /* STABLE */,
                                __: [0]
                            })
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => _cache[1] || (_cache[1] = [
                                    _createTextVNode(" mdi-storefront-outline ")
                                ])),
                                _: 1 /* STABLE */,
                                __: [1]
                            })
                        ]),
                        _createElementVNode("b", null, _toDisplayString(storeName.value), 1 /* TEXT */),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t(lc + 'selected_store_related_order')) + " ", 1 /* TEXT */),
                        _createElementVNode("b", _hoisted_6, _toDisplayString(getterSelectedStoreOrderList.value.length), 1 /* TEXT */),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t(lc + 'number')), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getterSelectedStoreOrderList.value, (item) => {
                            return (_openBlock(), _createBlock(OrderItem, {
                                key: item.orderId,
                                "is-selected": includesSelectedItemList.value(item.orderId),
                                "order-data": item,
                                "on-click-order-item": handleClickOrderItemForStore,
                                "hub-id": hubId.value,
                                "is-related-order": ""
                            }, null, 8 /* PROPS */, ["is-selected", "order-data", "hub-id"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ])
                ], 512 /* NEED_PATCH */), [
                    [_vShow, Object.keys(getterSelectedStoreOrderList.value).length > 0]
                ]),
                _createCommentVNode(" 선택된 라이더의 배차건 "),
                _withDirectives(_createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("span", _hoisted_10, [
                            _createVNode(_component_v_icon, {
                                class: "btn-close-related-order",
                                color: "black",
                                onClick: handleClickWorkerClose
                            }, {
                                default: _withCtx(() => _cache[2] || (_cache[2] = [
                                    _createTextVNode(" mdi-close ")
                                ])),
                                _: 1 /* STABLE */,
                                __: [2]
                            })
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => _cache[3] || (_cache[3] = [
                                    _createTextVNode(" mdi-moped ")
                                ])),
                                _: 1 /* STABLE */,
                                __: [3]
                            })
                        ]),
                        _createElementVNode("b", null, _toDisplayString(workerName.value), 1 /* TEXT */),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t(lc + 'selected_worker_related_order')) + " ", 1 /* TEXT */),
                        _createElementVNode("b", _hoisted_12, _toDisplayString(getterSelectedWorkerOrderList.value.length), 1 /* TEXT */),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t(lc + 'number')), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getterSelectedWorkerOrderList.value, (item) => {
                            return (_openBlock(), _createBlock(OrderItem, {
                                key: item.orderId,
                                "is-selected": includesSelectedItemList.value(item.orderId),
                                "order-data": item,
                                "on-click-order-item": handleClickOrderItemForWorker,
                                "hub-id": hubId.value,
                                "is-related-order": ""
                            }, null, 8 /* PROPS */, ["is-selected", "order-data", "hub-id"]));
                        }), 128 /* KEYED_FRAGMENT */)),
                        _withDirectives(_createVNode(_component_v_card, null, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_text, { class: "t-c" }, {
                                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                                        _createTextVNode(" 배차한 주문이 없습니다. ")
                                    ])),
                                    _: 1 /* STABLE */,
                                    __: [4]
                                })
                            ]),
                            _: 1 /* STABLE */
                        }, 512 /* NEED_PATCH */), [
                            [_vShow, getterSelectedWorkerOrderList.value.length === 0]
                        ])
                    ])
                ], 512 /* NEED_PATCH */), [
                    [_vShow, selectedWorker.value]
                ]),
                _createCommentVNode(" 일반 주문 "),
                _createElementVNode("div", {
                    ref_key: "orderListOuter",
                    ref: orderListOuter,
                    class: "order-list"
                }, [
                    _withDirectives(_createElementVNode("div", { class: "pt-5 text-center" }, _toDisplayString(resultText.value), 513 /* TEXT, NEED_PATCH */), [
                        [_vShow, isEmpty.value]
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getterMainOrderList.value, (item) => {
                        return (_openBlock(), _createBlock(OrderItem, {
                            ref_for: true,
                            ref: (el) => orderList.value[item.orderId] = el,
                            key: item.orderId,
                            "is-selected": includesSelectedItemList.value(item.orderId),
                            "order-data": item,
                            "hub-id": hubId.value,
                            "on-click-order-item": handleClickOrderItem
                        }, null, 8 /* PROPS */, ["is-selected", "order-data", "hub-id"]));
                    }), 128 /* KEYED_FRAGMENT */))
                ], 512 /* NEED_PATCH */)
            ]));
        };
    }
});
